export default __webpack_public_path__ + "static/media/wifi.88fe6d8d.svg";